export const siteInfo = {
  name: "年轻的母亲",
  englishName: "Young Mother",
  slogan: "全集畅看 · 剧情深读",
  tagline: "一部关于成长、亲情与选择的光影长卷",
  description:
    "《年轻的母亲》专题影视内容站，专注为观众提供电视剧全集分集入口、分集剧情介绍、整体剧情梗概、角色解析与热门解读，帮助你在一个地方看懂这部剧的每一个细节。",
  contactEmail: "contact@young-mother.demo",
  contactPhone: "010-8888 6666",
  address: "北京市朝阳区光影路 88 号 影视大厦 12 层",
  workTime: "周一至周五 09:00 - 18:00",
  copyright: "© 2025 年轻的母亲 · 影视内容站 保留所有权利",
  icp: "京 ICP 备 2025xxxxxx 号 · 本站内容仅供演示",
};